import React, { Component } from "react";
import { Container, Grid, List, Segment } from "semantic-ui-react";
import Link from "gatsby-link";

export default class FooterMenu extends Component {
  render() {
    return (
      <Segment inverted>
        <Container className="main_content">
          <Grid doubling columns={3} centered divided stretched>
            <Grid.Column>
              <List>
                <List.Item>
                  <List.Content as="h4">waller-welt.com</List.Content>
                </List.Item>
                <List.Item>
                  <List.Icon name="marker"/>
                  <List.Content>46030 Borgoforte ( MN ) Italien</List.Content>
                </List.Item>
                <List.Item>
                  <List.Icon name="phone"/>
                  <List.Content>
                    <p>Tel: 0039-345-9973997</p>
                  </List.Content>
                </List.Item>

                <List.Item>
                  <List.Icon name="mail"/>
                  <List.Content>
                    <a href="mailto:info@wallerwelt.com">info@wallerwelt.com</a>
                  </List.Content>
                </List.Item>
                <List.Item>
                  <List.Icon name="linkify"/>
                  <List.Content>
                    <a href="http://www.wallerwelt.com">wallerwelt.com</a>
                  </List.Content>
                </List.Item>
              </List>
            </Grid.Column>

            <Grid.Column>
              <List>
                <List.Item>
                  <List.Icon name='facebook' size='big' verticalAlign='middle'/>
                  <List.Content>
                    <a href="https://www.facebook.com/Wallerwelt-by-Markus-Eule-296950883708594/">
                      <p>Waller-Welt</p>
                    </a>
                  </List.Content>
                </List.Item>
                <List.Item>
                  <List.Icon name='facebook' size='big' verticalAlign='middle'/>
                  <List.Content>
                    <a href="https://www.facebook.com/groups/1148607495253649/">
                      <p>Wallerangeln am Po</p>
                    </a>
                  </List.Content>
                </List.Item>
                <List.Item>
                  <List.Icon name='youtube' size='big' verticalAlign='middle'/>
                  <List.Content>
                    <a href="https://www.youtube.com/channel/UCaKUrQs8CS66HTn2QA1o2Jg">
                      <p>Mister Waller</p>
                    </a>
                  </List.Content>
                </List.Item>
              </List>
            </Grid.Column>

            <Grid.Column>
              <List>
                <List.Item>
                  <List.Content>
                    <Link to="/kontakt">Kontakt</Link>
                  </List.Content>
                </List.Item>
                <List.Item>
                  <List.Content>
                    <Link to="/datenschutz">Datenschutz</Link>
                  </List.Content>
                </List.Item>
                <List.Item>
                  <List.Content>
                    <Link to="/impressum">Impressum</Link>
                  </List.Content>
                </List.Item>
                <List.Item>
                  <List.Content>
                    <Link to="/agb">AGB</Link>
                  </List.Content>
                </List.Item>
              </List>
            </Grid.Column>
          </Grid>

          <Grid>
            <Grid.Column
              textAlign="center">
              <p>© 2021 wallerwelt.com - created by <a href="https://www.siluri.de">siluri.de</a></p>
            </Grid.Column>
          </Grid>
        </Container>
      </Segment>
    )
      ;
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer/index.js